import * as React from "react";
import { RouteComponentProps } from "@reach/router";

export const AfterLogin = (props: AfterLoginProps) => {
  return <div>AfterLogin works!</div>;
};

type AfterLoginProps = RouteComponentProps;
